/**
 * Return the route identity used to reset the app-level error boundary.
 *
 * Query-string changes inside the same screen (for example Call Detail tabs)
 * must not remount the page: doing so discards local UI state and resets scroll.
 * A pathname change still resets the boundary, including when opening another call.
 */
export function getRouteBoundaryKey(location) {
  return location?.pathname || "/";
}
